console.log('Downloads Booting');
document.addEventListener("DOMContentLoaded", function() {
    console.log('Downloads Loading')
    import('./downloads.js').then(() => {
        console.log('Downloads Started')
    });
});
